<template>
	<!-- Main content -->
	<div class="content-wrapper">

		<!-- Page header -->
		<app-breadcrumb/>
		<!-- /page header -->

		<!-- Content area -->
		<div class="content">

			<!-- Simple panel -->
			<div class="panel panel-flat border-top-lg border-top-success">
				<div class="panel-heading">

					<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalAddServer" title="Add new server">
						<span>
							<i class="icon-plus22"></i>
							<span>Add new server</span>
						</span>
					</button>

				</div>

				<div class="panel-body">

					<!-- begin:Table Responsive-->
					<div class="table-responsive pt-10">
						<table class="table table-bordered table-hover" v-if="server_categories != ''">
							<thead>
								<tr class="active">
									<th>Server name</th>
									<th>Prefix</th>
									<th>Default server</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in server_categories">
									<td>{{ item.server_name }}</td>
									<td>{{ item.server_prefix }}</td>
									<td v-if="item.default_server == 0"><label class="btn btn-default btn-icon">Disabled</label></td>
									<td v-else><label class="btn bg-success btn-icon">Enabled</label></td>
									<td width="12%">
										<button class="btn btn-info btn-icon" type="button" @click.prevent="onShowEditServer(item.id)" title="Edit"><i class="icon-pencil5"></i></button>
										<button class="btn btn-danger btn-icon" type="button" title="Delete" @click.prevent="onDeleteServer(item.id)"><i class="icon-trash"></i></button>
									</td>
								</tr>
							</tbody>
						</table>

						<div v-else class="pt-10">No record found</div>
					</div>
					<!-- end:Table Responsive -->
					<pagination :pagination="pagination" @click.native="getDataPaging" :offset="4"></pagination>
				
				</div>
				<!-- end:panel-body -->

				<!-- begin::Modal Add Server -->
				<div class="modal fade" id="modalAddServer" tabindex="-1" role="dialog" aria-labelledby="ModalLabelAddServer">
					<div class="modal-dialog modal-lg">
						<div class="modal-content">
							<div class="modal-header bg-primary">
								<h5 class="modal-title" id="ModalLabelAdd">Add new server</h5>
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<!--begin::Modal Body -->
							<div class="modal-body">
								<!--begin::Form-->
								<form class="form-horizontal" id="formAddServer" @submit.prevent="onAddServer()">

									<div class="form-group">
										<label class="control-label col-sm-2">Server name: (*): </label>
										<div class="col-sm-10">
											<input type="text" class="form-control" name="server_name" v-model="server.server_name">
										</div>
									</div>

									<div class="form-group">
										<label class="control-label col-sm-2">Prefix: (*): </label>
										<div class="col-sm-10">
											<input type="text" class="form-control" name="server_prefix" v-model="server.server_prefix">
										</div>
									</div>


									<div class="form-group">
										<label class="control-label col-sm-2">Default server: (*): </label>
										<div class="col-sm-10">
											<select name="default_server" v-model="server.default_server" class="form-control">
												<option value="0">Disabled</option>
												<option value="1">Enabled</option>
											</select>
										</div>
									</div>

									<!--begin::Modal Footer -->
									<div class="modal-footer p-0 pt-10">
										<button class="btn btn-primary" data-style="zoom-out" type="submit" title="Add"><i class="icon-plus2"></i> Add</button>
										<button class="btn btn-default" type="button" data-dismiss="modal" title="Close"><i class="icon-cross"></i> Close</button>
									</div>
									<!--end::Modal Footer -->

								</form>
								<!--begin::Form-->
							</div>
							<!--end::Modal Body -->
						</div>
					</div>
				</div>
				<!-- end::Modal Add Server -->

				<!-- begin::Modal Edit Server -->
				<div class="modal fade" id="modalEditServer" tabindex="-1" role="dialog" aria-labelledby="ModalLabelEdit">
					<div class="modal-dialog modal-lg">
						<div class="modal-content">
							<div class="modal-header bg-info">
								<h5 class="modal-title" id="ModalLabelEdit">Edit Server</h5>
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<!--begin::Modal Body -->
							<div class="modal-body">
								<!--begin::Form-->
								<form class="form-horizontal" id="formEditServer" @submit.prevent="onEditServer(cloneServer.id)">

									<div class="form-group">
										<label class="control-label col-sm-2">Server name: (*): </label>
										<div class="col-sm-10">
											<input type="text" class="form-control" name="server_name" v-model="cloneServer.server_name">
										</div>
									</div>

									<div class="form-group">
										<label class="control-label col-sm-2">Prefix: (*): </label>
										<div class="col-sm-10">
											<input type="text" class="form-control" name="server_prefix" v-model="cloneServer.server_prefix">
										</div>
									</div>

									<div class="form-group">
										<label class="control-label col-sm-2">Default server: (*): </label>
										<div class="col-sm-10">
											<select name="default_server" v-model="cloneServer.default_server" class="form-control">
												<option value="0">Disabled</option>
												<option value="1">Enabled</option>
											</select>
										</div>
									</div>

									<!--begin::Modal Footer -->
									<div class="modal-footer p-0 pt-10">
										<button class="btn btn-info" data-style="zoom-out" type="submit" title="Save changes"><i class="icon-checkmark2"></i> Save changes</button>
										<button class="btn btn-default" type="button" data-dismiss="modal" title="Close"><i class="icon-cross"></i> Close</button>
									</div>
									<!--end::Modal Footer -->
								</form>
								<!--begin::Form-->
							</div>
							<!--end::Modal Body -->
						</div>
					</div>
				</div>
				<!-- end::Modal Edit Server -->

			</div>
			<!-- /simple panel -->

			<!-- Footer -->
			<app-footer/>
			<!-- /footer -->

		</div>
		<!-- /content area -->
	</div>
	<!-- /main content -->
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')

export default {
	name: 'Servers',
	data () {
		return {
			server: {
				default_server: 0
			},
			cloneServer: {}
		}
	},
	computed: {
		server_categories () {
			return this.$store.getters.server_categories
		},
		pagination () {
			return this.$store.getters.pagination_categories
		}
	},
	mounted() {
		let vm = this;
		Ladda.bind('button[type=submit]')
		return this.$store.dispatch('loadDataServer')
	},
	methods:{
		getDataPaging(){
			return this.$store.dispatch('loadDataServer')
		},
		onAddServer(){
			this.$store.commit('onAddServer', this.server)
		},
		onShowEditServer(serverID){
		  let index = this.server_categories.map(u => u.id).indexOf(serverID)
		  this.cloneServer = _.cloneDeep(this.server_categories[index])
		  $('#modalEditServer').modal('show')
		},
		onEditServer(){
		  this.$store.commit('onEditServer', this.cloneServer)
		},
		onDeleteServer(id){
			let vm = this;
			Swal.fire({
				title: "Are you sure?",
				text: "You will not be able to recover this Server!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#FF7043",
				confirmButtonText: "Yes, delete it!"
			}).then((result) => {
				  if (result.value) {
					axios.post('server/delete?token=' + token, {'id': id})
					.then(function (response) {
						Ladda.stopAll()
						vm.$store.dispatch('loadDataServer')
						$('#modalEditServer').modal('hide')
						vm.notify('success_delete')
					})
					.catch(function (error) {
						Ladda.stopAll()
						$('#modalEditServer').modal('hide')
						vm.notify('error_delete')
					});
				  }
				});
		}
	}
	///
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Servers.vue